import gql from 'graphql-tag';

export default gql`
  mutation UpdateWhitelabel($whiteLabel: WhitelabelInput!) {
    updateWhitelabel(whitelabel: $whiteLabel) {
      _id
    }
  }
`;
